import { Autoplay, Pagination } from 'swiper/modules';
import Swiper from 'swiper';

export default function initHeroSlider() {
  Alpine.data('heroSlider', () => ({
    swiper: null as Swiper | null,
    isAutoplaying: true,
    init() {
      const slider = this.$el.querySelector('.hero-swiper') as HTMLElement;
      if (slider) {
        this.swiper = new Swiper(slider, {
          modules: [Autoplay, Pagination],
          slidesPerView: 1,
          loop: true,
          autoplay: {
            delay: 5000,
          },
          pagination: {
            el: `#${this.$el.id} .hero-swiper-pagination`,
            type: 'bullets',
            bulletClass: 'cursor-pointer size-2 rounded bg-light/40 hover:bg-light transition-all',
            bulletActiveClass: 'w-8 rounded-full bg-light!',
            bulletElement: 'div',
            clickable: true,
          },
          on: {
            autoplayTimeLeft(swiper, time, progress) {
              const progressCircle = swiper.el.querySelector('.progress-circle') as HTMLElement;
              if (progressCircle) {
                progressCircle.style.setProperty('--progress', (1 - progress).toString());
              }
            },
          },
        });
      }
    },
    toggleAutoplay() {
      if (this.swiper) {
        if (this.swiper.autoplay.running) {
          this.swiper.autoplay.stop();
          this.isAutoplaying = false;
        } else {
          this.swiper.autoplay.start();
          this.isAutoplaying = true;
        }
      }
    },
  }));
}
